import RestService from "./RestService";


export default class EventsService extends RestService {
    constructor() {
        super('/api/events');
    }

    async ticketProofSettings() {
        return this.get(`${this.baseUrl}/ticket-proof-settings`);
    }

    async ticketProofAccess() {
        return this.get(`${this.baseUrl}/ticket-proof-access`);
    }
}
